<template>
    <div class="app-container">
      <BjDivider right-fixed>Storage Report</BjDivider>
      <el-table :data="tableData" style="width: 100%" border>
        <el-table-column prop="Customer" label="Customer" align="center"> </el-table-column>
        <el-table-column prop="Year" label="Year" align="center"> </el-table-column>
        <el-table-column prop="Week" label="Week" align="center"> </el-table-column>
        <el-table-column prop="Start" label="Start Time" align="center"> </el-table-column>
        <el-table-column prop="End" label="End Time" align="center"> </el-table-column>
        <el-table-column prop="Amount" label="Storage Pallet Amount" align="center"> </el-table-column>
      </el-table>
    </div>
  </template>
  <script>
  import { billApi } from '@/api';
  export default {
  name: 'BusinessBillingStorageReport',
  components: {},
  props: {
    businessType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      colSpan: 8,
      // 查询参数
      queryApi: billApi.getBillCategoryList,
      queryParams: {
        UserName: null,
        ChargeItem: null,
        Count: null,
        Comments: null,
      },

      tableData: [
        {
            Customer: 'SBOSELLO',
            Year: '2024',
            Week: '0',
            Start: '2023-12-28',
            End: '2024-01-04',
            Amount: '10458',
        },
      ],
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  destroyed() {},
  methods: {
    /** 重置按钮操作 */
    beforeResetSearch() {
      return new Promise(resolve => {
        resolve();
      });
    },
  },
  };
  </script>
  <style lang="scss" scoped>
  .el-icon-s-flag {
  float: right;
  line-height: 34px;
  }
  </style>
